export default __webpack_public_path__ + "static/media/logo.df2c3681.png";